// ============================================================================
// TERNARY SEARCH - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'ternary-search',
  name: 'Ternary Search',
  category: 'Search',
  complexity: {
    time: 'O(log₃ n)',
    space: 'O(1)'
  },
  description: 'Ternary Search divides the search space into three parts and recursively searches the relevant part. It is particularly useful for finding maximum or minimum of unimodal functions.'
};
export type MetaType = typeof meta;
